import { useSelector } from 'react-redux';

export const createSelectorHook = (selector) => (...args) => useSelector((state) => selector(state, ...args));
